<template>
    <div class='consultationRecordStudentAdd'>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm content">
            <div class="lineBox theme">
                <p>本次咨询主题：</p>
                <el-form-item  prop="interviewTheme">
                    <el-input label=""  v-model="ruleForm.interviewTheme" placeholder="请填写咨询主题" ></el-input>
                </el-form-item>
            </div>
            <div class="lineBox">
                <CircleName name="学生主要问题" ></CircleName>
                <el-form-item  prop="mainProblem" class="elForm">
                    <el-input label=""  type="textarea" v-model="ruleForm.mainProblem" placeholder="请填写"  :rows="4" ></el-input>
                </el-form-item>
            </div>
            <div class="lineBox">
                <CircleName name="咨询要点记录"></CircleName>
                <el-form-item  prop="consultantPoints" class="elForm">
                    <el-input label=""  type="textarea" v-model="ruleForm.consultantPoints" placeholder="请填写"  :rows="4" ></el-input>
                </el-form-item>
            </div>
            <div class="lineBox">
                <CircleName name="建议解决对策"></CircleName>
                <el-form-item  prop="recommendSolution" class="elForm">
                    <el-input label=""  type="textarea" v-model="ruleForm.recommendSolution" placeholder="请填写"  :rows="4" ></el-input>
                </el-form-item>
            </div>
            <div class="summary">
                <SummaryTitle title='咨询记录'/>
                <el-form-item  prop="consultSummary">
                    <el-input  type="textarea" v-model="ruleForm.consultSummary" placeholder="请填咨询总结"  :rows="5" ></el-input>
                </el-form-item>
            </div>
        </el-form>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <!--<Button @handleClick="submitForm('ruleForm',true)" :type="'btnGray'" name="预览" ></Button>-->
            <Button @handleClick="submitForm('ruleForm',false)" :type="'btnBlue'" name="保存" ></Button>
        </div>
        <InterviewPopup :interviewRecord="interviewRecord" :isInputReadOnly="isInputReadOnly"  v-on:closePop="()=>isShowPop=false" v-show="isShowPop"></InterviewPopup>
    </div>
</template>
<script>
import InterviewPopup from '@/components/consultant/InterviewPopup.vue';
import CircleName from '@/components/consultant/CircleName.vue';
import SummaryTitle from '@/components/consultant/SummaryTitle.vue';
import Button from '@/components/Button.vue';

export default {
    name: "consultationRecordStudentAdd",
    components: {
        Button,
        CircleName,
        SummaryTitle,
        InterviewPopup
    },
    data() {
        return {
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            isShowPop:true,
            isInputReadOnly: true,
            //咨询记录
            interviewRecord: {
                category: 5,//类别：1首次访谈 2规划内容 3 目标拆分 4行动计划 5自由主题
                interviewTime: '',//时间
                interviewNum: '',//次数
                interviewTheme: '自由主题',//主题,
            },

            ruleForm: {
                interviewTheme:'',
                mainProblem: '',//主要问题描述
                consultantPoints: '',//咨询要点记录
                recommendSolution: '',//建议解决方案
                consultSummary: '',//咨询总结
            },
            rules: {
                mainProblem: [
                    { required: true, message: '请填写', trigger: 'change' },
                ],
                consultantPoints: [
                    { required: true, message: '请填写', trigger: 'change' },
                ],
                recommendSolution: [
                    { required: true, message: '请填写', trigger: 'change' },
                ],
                consultSummary: [
                    { required: true, message: '请填写', trigger: 'change' },
                ],
            }


        }
    },
    created() {

    },
    methods: {
        submitForm(formName) {
            console.log(this.ruleForm)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let freeThemeObj = this.ruleForm;
                    let interviewRecord= this.interviewRecord;
                    let freeTheme = {
                        mainProblem: freeThemeObj.mainProblem,
                        consultantPoints: freeThemeObj.consultantPoints,
                        recommendSolution: freeThemeObj.recommendSolution,
                        consultSummary: freeThemeObj.consultSummary,
                    }
                    let studentId = this.studentId;
                    interviewRecord.interviewTheme = freeThemeObj.interviewTheme;
                    this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.consultationRecord.storeStudentInterviewFreeTheme, {
                        freeTheme,interviewRecord,studentId
                    }, {
                        headers: {
                            token: window.sessionStorage.getItem('ymtxToken')
                        }
                    }).then((res) => {
                        if (res.data.code == 2000) {
                            let id = res.data.data.id;
                            this.$router.replace({path:'/consultant/minestudent/main/consultationRecord/student/detail',query:{id: id}})
                        }
                    })

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        }
    },
}
</script>

<style scoped lang="less">
.consultationRecordStudentAdd {
    .content {
        padding: 6px 30px 8px 30px;
        background-color: #fff;
        .elForm {
            padding-top: 16px;
        }
        .lineBox {
            margin-bottom: 32px;
        }
        .theme {
            display: flex;
            align-items: center;
            p {
                font-size: 20px;
                font-weight: 500;
            }
            input {
                flex: 1;
            }
        }
    }
    .ftBtnBox {
        padding: 45px 0;
        display: flex;
        justify-content: center;
    }
}
</style>
<style lang="less">
.consultationRecordStudentAdd {
    input {
        border: 1px solid #EAEAEA;
        background-color: #FDFDFD;
    }
    .theme {
        display: flex;
        align-items: center;
        p {
            font-size: 20px;
            font-weight: 500;
        }
        .el-form-item {
            flex: 1;
            margin-bottom: 0;
        }
    }
}
</style>